import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {Table} from "../../shared/model/table";
import {Restaurant} from "../../shared/model/restaurant";
import {ActivatedRoute, Router} from "@angular/router";
import {Overlay} from "angular2-modal";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {TableService} from "../../shared/services/table/table.service";


@Component({
  selector: 'table-create',
  templateUrl: 'table-create.component.html',
  styleUrls: ['table-create.component.css']
})
export class TableCreateComponent implements OnInit {
  table:Table;
  selectedStatus:string;
  private currentRestaurant: Restaurant;
  private currentRestaurantName: string;
  private restaurantId:string;

  constructor(
    private tableservice:TableService,
    private router: Router,
    private route: ActivatedRoute,
    public modal: Modal,
    overlay:Overlay,
    vcRef:ViewContainerRef
  ) {
    this.table = Object.assign({});
  }

  ngOnInit() {

    let myRoute = this.route.snapshot;
    this.restaurantId = myRoute.params['id'];



  }


  Create(form){

    const isValid  = form.valid;



    if(isValid){


      this.table.tableName = form.value.tableName;
      this.table.status = form.value.status;
      this.table.statusForTable = "<span class=\"status-class "+form.value.status+"\">"+form.value.status+"</span>";
      this.table.restaurant_id = this.restaurantId;
      this.table.statusStartedTime =  String(new Date().getTime() / 1000);
      this.table.edit = "<span class=\"glyphicon glyphicon-edit\"></span>";
      this.table.isActive = form.value.isActive;
      this.table.seats = form.value.seats;

      this.createTable(this.table);

    } else {
      form.showErrors();
    }
  }

  select(selectedStatus:string) {

    this.selectedStatus = selectedStatus;

  }

  cancel() {
    this.router.navigate(['/restaurants/'+this.restaurantId])
  }


  private createTable(table:Table){

    const createTable$ = this.tableservice.createTable(table);
    createTable$
      .subscribe(()=>
        {
          this.router.navigate(['/restaurants/'+this.restaurantId])
        },err =>  this.messageIt('Error creating table ',err))


  }

  messageIt(titleP: string, messageP: string) {

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }


}



// WEBPACK FOOTER //
// ./src/app/table/table-create/table-create.component.ts